<template>
    <div class="home-news-box">
        <div class="p-t44-l30">
            <div class="home-news">
                <div class="home-news-title">资讯速递</div>
                <div class="home-news-more" @click="jumpTo(is4399 ? 'https://my.4399.com/yxssjj2/xinwen/' : 'https://www.ssjj.cn/articles')">查看更多>></div>
            </div>
            <swiper class="swiper my-swiper-box" :options="swiperOption" v-if="lunbo.length">
                <swiper-slide v-for="s in lunbo" :key="s.id">
                    <div class="my-swiper">
                        <img :src="s.image" style="width: 100%; height: 100%;cursor: pointer;" alt="" :redirect-url="s.redirect_url">
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div class="paly-now">即刻畅玩</div>
            <div class="paly-down"></div>
        </div>
        <div class="play-info">
            <div v-if="token" class="login-info">
                <div class="user-logo"></div>
                <div class="user-info">
                    <div class="user-name">
                        <div>{{ account }}</div>
                        <div class="user-logout" @click="signOut"> <span class="exit"></span><span>退出</span></div>
                    </div>
                    <div class="user-limit">
                        <div class="limit-text">剩余时长：</div>
                        <div class="limit-num">
                            <span>{{
                                    secondsToTime(limitTime, 'day')[0]
                                }}</span>天<span>{{
                                secondsToTime(limitTime, 'day')[1]
                            }}</span>时<span>{{ secondsToTime(limitTime, 'day')[2] }}</span>分
                        </div>
                        <div style="position: relative">
                            <div v-if="missionCompleteStatus" class="has-red-point"></div>
                            <img class="get-time" @click="buyTime" src="../assets/images/home/get-time.png" alt="">
                        </div>

                    </div>
                </div>
            </div>
            <div v-else class="no-login-info">
                <div style="color: #F2C075;" @click="showLoginFunc(true, 'login')">登录</div>
                <span style="margin: 0 10px;">|</span>
                <div @click="showLoginFunc(true, 'register')">注册</div>
            </div>
            <div class="start-info">
                <div style="position: relative;">
                    <img class="start-btn" @click="startGame" src="../assets/images/home/start-btn.png" alt=""/>
                    <img class="new-player-tip" v-if="tip" :src="tip" alt=""/>
                </div>
                <div class="handle-box">
                    <img class="handle-btn" @click="downloadClient" src="../assets/images/home/download-game.png" alt=""/>
                    <img class="handle-btn" @click="submitSave" v-if="supportInstall && !is4399" src="../assets/images/home/save-desktop.png" alt=""/>
                </div>
            </div>
        </div>
        <div class="play-qa p-t44-l30">
            <div class="home-news">
                <div class="home-news-title">常见问题FAQ</div>
                <div class="home-news-more" @click="jumpTo(is4399 ? 'http://my.4399.com/zhuanti/ssjj2/xszn' : 'https://www.wooduan.com/service/service/630ebde509187f8e02edde1d')">查看更多>></div>
            </div>
            <div class="qa-box">
<!--                <div>-->
<!--                    <div ></div>-->
<!--                </div>-->
                <el-collapse accordion v-model="activeName" @change="handleChange">
                    <el-collapse-item  v-for="qa in faqList" :key="qa.id" :title="qa.title" :name="qa.id">
                        <div v-html="answerList[qa.id]"></div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { tokenName, getMemberCenterUrl, secondsToTime } from '@/utils/util'

export default {
    props: {
        limitTime: {
            type: Number,
            default: 0
        },
        channel_id: {
            type: Number,
            default: 1
        },
        showHome: {
            type: Boolean,
            default: false
        },
        lunbo: {
            type: Array,
            required: true,
        },
        supportInstall: {
            type: Boolean,
            default: false
        },
        token: {
            type: String,
            default: ''
        },
        downloadUrl: {
            type: String,
            default: ''
        },
        tip: {
            type: String,
            default: ''
        },
        account: {
            type: String,
            default: ''
        },
        channelLogin: {
            type: Boolean,
            default: false,
        },
        showLogo: {
            type: Boolean,
            default: true,
        }
    },
    components: {
    },
    computed: {
        ...mapGetters(['missionCompleteStatus', 'is4399'])
    },
    data () {
        return {
            faqList: [], // faq列表
            answerList: {}, // faq答案对象
            activeName: '',
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true
                },
                autoplay: {
                    delay: 3000,
                },
                loop: true,
                observer: true,
                observeParents: true,
                loopFillGroupWithBlank: true,
                on: {
                    click: (e) =>  {
                        const id = e.target.getAttribute('data-id');
                        const redirectUrl = e.target.getAttribute('redirect-url');
                        console.log(redirectUrl)
                        if (/^((https|http)?:\/\/)[^\s]+/.test(redirectUrl)) {
                            window.open(redirectUrl, "_blank")
                        }
                        // const id = e.target.getAttribute('data-id');
                        // const redirectUrl = e.target.getAttribute('redirect-url');
                        // if (redirectUrl) {
                        //     this.jumpTo(redirectUrl, 'activityId_' + id)
                        // }
                    }
                }
            },
            from: '',
            showLoginCon: false,
            showGuideText: true,
            showOtherMask: false,
            memberUrl: getMemberCenterUrl(process.env.VUE_APP_ENV)
        }
    },

    mounted () {
        this.from = this.$route.query.from || 'webyun_426100001';
        setTimeout(() => {
            this.showGuideText = false;
        }, 10000)
        this.queryFAQ();
    },
    methods: {
        queryFAQ () {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/cloud/FAQ', {
                page: 1,
                page_size: 100,
                channel_id: this.channel_id
            }).then((res) => {
                console.log(res, '--FAQ----');
                this.faqList = res.Result;
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        secondsToTime,
        ...mapMutations(['setShowLogin']),
        jumpTo (url) {
          window.open(url, "_blank")
        },
        handleChange (newsId) {
            console.log(newsId)
            if (newsId && !this.answerList[newsId]) {
                this.queryAnswer(newsId)
            }
        },
        queryAnswer (newsId) {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/news/detail', { id: newsId }).then((res) => {
                console.log(res, '--queryAnswer----');
                this.answerList[newsId] = res.content;
                this.answerList = { ...this.answerList }
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        downloadClient () {
            window.open(this.downloadUrl, '_blank');
        },
        submitSave () {
            this.$parent.setYunLog(2)
            this.$emit('submitSave')
        },
        startGame () {
            this.$emit('startGame')
        },
        buyTime () {
            console.log('buyTime')
            this.$emit('buyTime')
        },
        threeLogin (type, width = 680, height = 650) {
            console.log(this.memberUrl, '---this.memberUrl---')
            const parmas = 'height=' + height + ', width=' + width + ',toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no';
            const returnUrl = 'https://h5.ssjj.cn/common/thirdlogin/index.html?app_key=website&lng=zh&platform=pc';
            let url = ''
            if (this.$route.query.from) {
                url = `${this.memberUrl}/v1/third/index?type=${type}&app_key=website&is_bind=false&return_url=${encodeURIComponent(returnUrl)}&from=${this.$route.query.from ? this.$route.query.from : ''}`
            } else {
                url = `${this.memberUrl}/v1/third/index?type=${type}&app_key=website&is_bind=false&return_url=${encodeURIComponent(returnUrl)}`
            }

            const selfLoginWindow = window.open(
                url,
                type,
                parmas
            );
            window.addEventListener("message", (a) => {
                if (a.data.token) {
                    selfLoginWindow.close()
                    // this.getUserToken(a.data)
                    this.$emit('login', a.data, 'login')
                    window.removeEventListener("message", () => {
                        console.log("事件结束");
                    });
                }
            })
        },
        showLoginFunc (status, type) {
            this.$emit('log', 25)
            if (this.is4399) {
                this.threeLogin('4399')
            } else {
                this.setShowLogin(status)
                this.initLogin()
            }
        },
        initLogin () {
            const option = {
                container: '#loginIn', // 容器，支持选择器默认是body
                useCookie: false, // 是否使用cookie存储token，否则使用localStorage，默认为false
                tokenName, // cookie或者localStorage的key,不传会自动生成
                appName: '', // 业务名 'website' 网站 或'client' 登录器，默认website
                lng: 'zh', // 适配语言， zh代表中文,目前只有
                platform: 'pc', // 适配设备，pc或移动端，不传会自动根据userAgent判断
                mode: process.env.VUE_APP_ENV, // 环境，不传默认为master
                // mode: 'pre', // 环境，不传默认为master
                channel_id: 1, // 渠道id
                sub_channel_id: 4261, // 子渠道id
                // channelLogin: this.channelLogin,
                // autoShowChannelLogin: this.channelLogin && !!this.$route.query.fromChannel, // 有渠道登录并且有来自渠道的标记 则自动显示渠道登录
                from: this.from, // 渠道重构后的参数 channel_id,sub_channel_id 默认不传，服务端根据from判断渠道来源,
            }
            window.instance = window.initUnilogin(option)
            instance.login()
            // 增加登录事件监听
            instance.on('login', (r) => {
                // this.getUserToken(r)
                this.$emit('login', r, 'login')
            })
            instance.on('register', (r) => {
                // this.getUserToken(r)
                this.$emit('login', r, 'register')
            })
        },
        signOut () {
            this.$emit('signOut', true)
        },
        handleLogoClick () {
            this.$emit('logoClick')
        }
    }
}
</script>
<style scoped lang="less">

.home-news-box {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    .play-info {
        background-image: url("../assets/images/home/play-info-bg.png");
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-size: 100% 100%;
        width: 100%;
        height: 220px;
        padding: 18px 30px;
        .no-login-info {
            display: flex;
            flex-direction: row;
            font-size: 20px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
            justify-content: center;
            height: 52px;
            line-height: 52px;
            >div {
                cursor: pointer;
            }
        }
        .login-info {
            height: 52px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
        .user-logo {
            background-image: url("../assets/images/home/user-logo.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 52px;
            height: 52px;
            overflow: hidden;
            border-radius: 50%;
            margin-right: 18px;
        }
        .user-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 16px;
        }
        .user-name {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        .user-logout {
            cursor: pointer;
            display: flex;
            align-items: center;
        }
        .exit {
            width: 15px;
            height: 13px;
            display: inline-block;
            background-image: url("../assets/images/home/exit.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .user-limit {
            display: flex;
            justify-content: flex-start;
            height: 21px;
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
        }
        .limit-num {
            color: #BB2232;
            margin: 0 10px;
        }
        .has-red-point {
            position: absolute;
            width: 14px;
            height: 14px;
            opacity: 1;
            border: 1px solid #FFFFFF;
            border-radius: 50%;
            background: #BB2232;
            right: -7px;
            top: -7px;
        }
        .get-time {
            width: 80px;
            height: 20px;
            vertical-align: bottom;
            cursor: pointer;
        }
        .limit-text {
            color: #F2C075;
        }
        .start-info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 20px;
            .start-btn {
                width: 318px;
                height: 98px;
                cursor: pointer;
                vertical-align: bottom;
            }
            .new-player-tip {
                position: absolute;
                top: -10px;
                left: -10px;
                width: 240px;
                height: 24px;
                vertical-align: bottom;
            }
            .handle-box {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
            }
            .handle-btn {
                width: 138px;
                vertical-align: bottom;
                cursor: pointer;
                height: 40px;
            }
        }
    }
    .p-t44-l30 {
        padding: 30px 30px 10px 30px;
    }
    .qa-box {
        background-image: url("../assets/images/home/qa-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 143px;
        width: 100%;
        margin: 20px 0;
        overflow-y: auto;
        padding: 0 20px;

        /deep/ .el-collapse-item__header {
            background-color: transparent !important;
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #B0CAEB;
            line-height: 19px;
        }
        /deep/ .el-collapse-item__header {
            border-bottom: none !important;
            border-top: none !important;
        }
        /deep/ .el-collapse-item__wrap {
            background-color: transparent !important;
            border-bottom: none !important;
        }
        /deep/ .el-collapse-item__content {
            color: #B0CAEB !important;
            text-indent: 20px;
            text-align: left;
            padding-bottom: 15px;
        }
        /deep/ .el-collapse {
            border: none !important;
        }
    }
}
.my-swiper-box {
    margin: 20px 0;
    border-radius: 8px;
    overflow: hidden;
}
.paly-now {
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 33px;
}
.paly-down {
    width: 48px;
    height: 29px;
    margin: 0 auto;
    background-image: url("../assets/images/home/index-top-scrolldown.png");
    background-repeat: no-repeat;
    background-size:  100% 100%;
    margin-top: 10px;
}
.home-news {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .home-news-title {
        font-size: 26px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 30px;
    }
    .home-news-more {
        font-size: 16px;
        cursor: pointer;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 19px;
        display: flex;
        align-items: center;
    }
}
.my-swiper {
    width: 490px;
    height: 276px;
}
//.show-shadow {
//    box-shadow: 0 0 30px #EC850A7F;
//    /*考虑浏览器兼容性*/
//    -moz-box-shadow: 0 0 30px #EC850A7F;
//    -webkit-box-shadow: 0 0 30px #EC850A7F;
//}
//.show-guide {
//    text-align: left;
//    margin-left: 20px;
//}
//.icon-logo {
//    height: 60px;
//    position: fixed;
//    top: 210px;
//    left: 50px;
//    cursor: pointer;
//    display: flex;
//    align-items: center;
//    font-size: 12px;
//    /*opacity: .5;*/
//}
//.hand-style {
//    position: absolute;
//    width: 40px;
//    height: 40px;
//    bottom: -20px;
//    left: 30px;
//}
//
//.icon-img {
//    width: 50px;
//    height: 50px;
//    margin-right: 10px;
//}
//.cursor-p {
//    cursor: pointer;
//}
//
//a {
//    text-decoration: none;
//}
//
//.common-login-center {
//    flex: 1;
//}
//
//.logo-container {
//    display: flex;
//    flex-direction: row;
//    color: #fff;
//    align-items: center;
//    width: 398px;
//    height: 92px;
//}
//
//.common-layout {
//    display: flex;
//    box-sizing: border-box;
//    justify-content: space-between;
//    padding: 20px;
//}
//
//.common-layout-img {
//    width: 100%;
//    height: 100%;
//}
//
//.loginCon {
//    width: auto;
//    padding-top: 4px;
//    box-sizing: border-box;
//    display: flex;
//    justify-content: flex-start;
//    align-items: center;
//}
//
//.common-login {
//    display: flex;
//    flex-direction: row;
//    justify-content: space-between;
//}
//
//.f-cb {
//    zoom: 1;
//}
//
//.unlogin, .haslogin {
//    display: flex;
//    flex-direction: row;
//    justify-content: flex-start;
//    color: #fff;
//    font-size: 18px;
//}
//
//.unlogin li,
//.haslogin li,
//.parent li {
//    margin-right: 20px;
//    height: 60px;
//    display: flex;
//    align-items: center;
//    cursor: pointer;
//    font-size: 12px;
//}
//
//.quick-login span {
//    display: inline-block;
//    line-height: 60px;
//    height: 60px;
//    vertical-align: bottom;
//}
//
//@keyframes btn_hover {
//    0% {
//        transform: scale(1);
//    }
//    100% {
//        transform: scale(0.93);
//    }
//}
//
//@keyframes btn_hover_light {
//    0% {
//        box-shadow: 0 0 0 #101010;
//    }
//    100% {
//        box-shadow: 0 0 40px #101010;
//    }
//}
//
//.tabs > div {
//    width: 159.8px;
//    display: inline-block;
//    line-height: 40px;
//    font-size: 20px;
//    color: #b2b7c0;
//    text-align: center;
//    position: relative;
//}
//
//.tabs > div.active {
//    color: #fff;
//    text-shadow: 0 0 10px #fff;
//}
//
//.tabs > div.active::after {
//    content: '';
//    position: absolute;
//    bottom: 0;
//    width: 26px;
//    height: 3px;
//    background: #ce292d;
//    left: 50%;
//    margin-left: -13px;
//}
//
//.tabs > div {
//    border-right: 1px solid #32363c;
//    cursor: pointer;
//}
//
//.tabs > div:last-child {
//    border: none;
//}
//
//@media screen and (max-width: 1000px) {
//    .container {
//        position: relative;
//        overflow: hidden;
//        font-family: 'Microsoft Yahei';
//        background: #000;
//        min-width: 1000Px;
//    }
//}
</style>
